import React from 'react';

import SelectFacet from '@plone/volto/components/manage/Blocks/Search/components/SelectFacet';

const SafeSelectFacet = (props) => {
  const hasInvalidSingleValue =
    !props.isMulti && Array.isArray(props.value?.value);

  return (
    <SelectFacet
      {...props}
      value={hasInvalidSingleValue ? null : props.value}
    />
  );
};

export default SafeSelectFacet;
